import { ReactElement } from 'react';

import {
    GenericGridFiltersProps
} from '@containers/activity-router/data-grid-container/generic-grid-filters/generic-grid-filters.types';

export type MultiSelectItems = (setIsActive: (isActive: boolean) => void) => ReactElement;

export type MultiSelectProps = Pick<GenericGridFiltersProps, 'multiSelectItems'>;

export type MultiSelectOption =
    | 'All Cells'
    | 'Assigned Now'
    | 'Assigned Later'
    | 'Overdue'
    | 'Low Range Correct results'
    | 'Mid Range Correct results'
    | 'High Range Correct results'
	| 'Incorrect results'
	| 'Partially Correct results'
	| 'Correct results'
    | 'Clear All'
	| 'Voluntary Attempts'
	| 'Number of Attempts';

export enum MultiSelectOptions {
    ALL_CELLS = 'All Cells',
    ASSIGNED_NOW = 'Assigned Now',
    ASSIGNED_LATER = 'Assigned Later',
    OVERDUE = 'Overdue',
    LOW_RANGE_CORRECT = 'Low Range Correct results',
    MID_RANGE_CORRECT = 'Mid Range Correct results',
    HIGH_RANGE_CORRECT = 'High Range Correct results',
    INCORRECT = 'Incorrect results',
    PARTIALLY_CORRECT = 'Partially Correct results',
    CORRECT = 'Correct results',
    CLEAR_ALL = 'Clear All'
}

export type MultiSelectMenuItem = {
    icon: ReactElement
    text: string
    id: MultiSelectOption
    color?: string
};

export type MultiSelectMenuItems = Array<MultiSelectMenuItem>;

export type MultiSelectGenerateItemsProps = {
    items: MultiSelectMenuItems
    callback: (id: string) => void
};
